import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import { FaDownload } from "react-icons/fa";
import ExitBulkInitiatePopup from "./ExitBulkInitiatePopup";
import { exitApi } from "./exitApi";

const PAGE_SIZE = 20;

// Exit bulk-initiate upload history (SheetUpload report_type "8"), laid out like SheetBulkUpload.
const ExitBulkInitiate = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const [sno, setsno] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [search, setsearch] = useState("");
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [bulkUploadPopup, setBulkUploadPopup] = useState(false);

  const pagesize = () => {};
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    [],
  );
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handleDownload = (url) => {
    if (!url) return;

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const loadHistory = useCallback(async () => {
    try {
      const res = await exitApi.bulkInitiateHistory({
        page_size: PAGE_SIZE,
        page: dtpageindex,
        search,
      });
      setRows(res.data || []);
      setTotalCount(res.total || 0);
    } catch {
      /* toast shown by exitApi */
    }
  }, [dtpageindex, search]);

  useEffect(() => {
    loadHistory();
  }, [loadHistory]);

  // Refresh while any upload is still processing in celery.
  useEffect(() => {
    if (!rows.some((item) => item.status === "0")) return;

    const interval = setInterval(loadHistory, 5000);
    return () => clearInterval(interval);
  }, [rows, loadHistory]);

  const downloadCell = (url, title) =>
    url ? (
      <span
        style={{ cursor: "pointer" }}
        onClick={() => handleDownload(url)}
        title={title}
      >
        <FaDownload size={18} />
      </span>
    ) : (
      "-"
    );

  const columns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => <p>{Number(sno + row.row.index + 1)}</p>,
      },
      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <span>{`${dateString.slice(0, 10) + "  " + formattedTime}`}</span>
          );
        },
      },
      {
        Header: "File Name",
        accessor: "file_name",
        Cell: (row) => (
          <span
            style={{
              width: "160px",
              display: "inline-block",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              textWrap: "wrap",
            }}
          >
            {row.row.original?.file_name}
          </span>
        ),
      },
      {
        Header: "Total Count",
        accessor: "total_count",
        Cell: (row) => <span>{row.row.original?.total_count}</span>,
      },
      {
        Header: "Sucess Count",
        accessor: "valid_count",
        Cell: (row) => <span>{row.row.original?.valid_count}</span>,
      },
      {
        Header: "Defect Count",
        accessor: "defect_count",
        Cell: (row) => <span>{row.row.original?.defect_count}</span>,
      },
      {
        Header: "Uploaded Sheet",
        accessor: "uploaded_sheet",
        Cell: (row) =>
          downloadCell(row.row.original?.uploaded_sheet, "Download Uploaded Sheet"),
      },
      {
        Header: "Success Sheet",
        accessor: "success_sheet",
        Cell: (row) =>
          downloadCell(row.row.original?.success_sheet, "Download Success Sheet"),
      },
      {
        Header: "Defect Sheet",
        accessor: "defect_sheet",
        Cell: (row) =>
          downloadCell(row.row.original?.defect_sheet, "Download Defect Sheet"),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          const status = row.row.original?.status;
          return (
            <span>
              {status == "0"
                ? "Pending"
                : status == "1"
                  ? "Completed"
                  : "Failed"}
            </span>
          );
        },
      },
    ],
    [rows, sno],
  );

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch"
          style={{
            padding: "14px 28px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px !important",
          }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 class="user-name mb-0">Exit Bulk Initiate</h3>
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={() => {
                setBulkUploadPopup(true);
              }}
              className="ButtonCSS"
              style={{ marginBottom: "10px" }}
            >
              Bulk Upload
            </button>
          </div>
        </div>
        <div
          style={{
            padding: " 0px 40px",
            marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          <ReactTable
            data={rows}
            columns={columns}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={PAGE_SIZE}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            totalItems={totalCount}
            datacount={totalCount}
            MakeCreate={false}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            placeHold={"All"}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            ApproveRequestFilter={true}
            search_key={true}
          />
        </div>
        {bulkUploadPopup && (
          <ExitBulkInitiatePopup
            setPopup={setBulkUploadPopup}
            onUploaded={() => (dtpageindex === 1 ? loadHistory() : setdtPageindex(1))}
          />
        )}
      </div>
    </>
  );
};

export default ExitBulkInitiate;
